// import { Divider, Grid, IconButton, Paper, Typography } from "@mui/material";
// import React, { useState } from "react";
// import { ReactComponent as ArrowUpwordCorner } from "../../../images/ArrowCorner.svg";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";

// export const LabRecentNotification: React.FC<any> = React.memo((props) => {
//   const filters = ["All", "Payments", "Return"];
//   const [selectedFilter, setSelectedFilter] = useState(filters[0]);

//   // ✅ Notification Data Array (MAP)
//   const notifications = [
//     {
//       icon: <WSIcons.BsBox2Fill style={{ color: "#CEEEE5", fontSize: 20 }} />,
//       text: "New test order #ORD1085 received for Full Body Checkup. ",
//       time: "3h",
//     },
//     {
//       icon: <WSIcons.TbCalculator style={{ color: "#CEEEE5", fontSize: 20 }} />,
//       text: "Sample collection scheduled tomorrow for Order #ORD1095 ",
//       time: "3h",
//     },
//     {
//       icon: <WSIcons.BsBox2Fill style={{ color: "#CEEEE5", fontSize: 20 }} />,
//       text: "Report delayed for Order #ORD1088, awaiting results",
//       time: "3h",
//     },
//     {
//       icon: (
//         <WSIcons.BsFileTextFill style={{ color: "#CEEEE5", fontSize: 20 }} />
//       ),
//       text: "COVID-19 RT-PCR for Order #LAB2098. ",
//       time: "3h",
//     },
//     {
//       icon: (
//         <WSIcons.GiEmptyMetalBucket
//           style={{ color: "#F21E1E", fontSize: 20 }}
//         />
//       ),
//       text: "Out of stock: Blood Glucose Test Strips",
//       time: "4h",
//     },
//     {
//       icon: (
//         <WSIcons.GiEmptyMetalBucket
//           style={{ color: "#F9E78C", fontSize: 20 }}
//         />
//       ),
//       text: "Only 10 units left: Lipid Profile Kits.",
//       time: "4h",
//     },
//     {
//       icon: (
//         <WSIcons.GiEmptyMetalBucket
//           style={{ color: "#F9E78C", fontSize: 20 }}
//         />
//       ),
//       text: "Only 5 units left: Paracetamol 500mg. ",
//       time: "4h",
//     },
//     {
//       icon: (
//         <WSIcons.PiShieldWarningFill
//           style={{ color: "#F9E78C", fontSize: 20 }}
//         />
//       ),
//       text: "Reagent batch expiry approaching: TSH Test Kit (exp. in 7 days). ",
//       time: "4h",
//     },
//   ];

//   return (
//     <Paper
//       elevation={0}
//       style={{
//         paddingLeft: 20,
//         paddingRight: 20,
//         marginTop: 40,
//         paddingBottom: 25,
//         borderRadius: "8px",
//       }}
//     >
//       <Grid container spacing={2}>
//         {/* Header */}
//         <Grid item xs={12} sm={10}>
//           <Typography>Recent Notifications</Typography>
//         </Grid>
//         <Grid item xs={12} sm={2}>
//           <ArrowUpwordCorner />
//         </Grid>

//         {/* Filter Buttons */}
//         <Grid item xs={12}>
//           <WSFilterButtonGroup
//             options={filters}
//             selected={selectedFilter}
//             onChange={(value) => {
//               setSelectedFilter(value);
//             }}
//           />
//         </Grid>

//         {/* Today Label */}
//         <Grid item xs={12}>
//           <Typography>Today</Typography>
//         </Grid>

//         {/* Notifications List Using MAP */}
//         {notifications.map((item, index) => (
//           <React.Fragment key={index}>
//             <Grid item xs={12} sm={2}>
//               <IconButton
//                 sx={{
//                   width: 30,
//                   height: 30,
//                   borderRadius: "8px",
//                   border: "1px solid #828584",
//                   p: 0,
//                 }}
//               >
//                 {item.icon}
//               </IconButton>
//             </Grid>

//             <Grid item xs={12} sm={10}>
//               <Typography>
//                 {item.text}{" "}
//                 <span style={{ color: "#828584" }}>{item.time}</span>
//               </Typography>
//             </Grid>

//             <Grid item xs={12}>
//               <Divider />
//             </Grid>
//           </React.Fragment>
//         ))}
//       </Grid>
//     </Paper>
//   );
// });








import { Box, ButtonBase, CircularProgress, Divider, IconButton, Paper, TablePagination, Typography } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import {
  getNotificationPath,
  useVendorNotifications,
  VendorNotification,
} from "../../../Components/Notifications/useVendorNotifications";

const COLORS = {
  primary: "#098963",
  dark: "#022219",
  muted: "#828584",
  border: "#CEEEE5",
  unreadBg: "#F3FBF8",
};

const formatTime = (value: string) => {
  const date = new Date(value);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

// Today / Yesterday / Earlier
const getDayGroup = (value: string) => {
  const date = new Date(value);
  if (isNaN(date.getTime())) return "Earlier";
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  const startOfYesterday = new Date(startOfToday);
  startOfYesterday.setDate(startOfYesterday.getDate() - 1);
  if (date >= startOfToday) return "Today";
  if (date >= startOfYesterday) return "Yesterday";
  return "Earlier";
};

interface LabRecentNotificationProps {
  limit?: number; // max items to show; omit to show all
  marginTop?: number;
  title?: string;
  // Adds a "view all" arrow in the header that opens this page
  viewAllPath?: string;
  // Splits the list into pages (Notifications page); paging happens in the browser
  paginate?: boolean;
}

const ROWS_PER_PAGE_OPTIONS = [10, 20, 50];

// Every notification (read and unread), newest first; shares its list with the header bell and drawer
export const LabRecentNotification: React.FC<LabRecentNotificationProps> = ({
  limit,
  marginTop = 40,
  title = "All Notifications",
  viewAllPath,
  paginate = false,
}) => {
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();
  const { notifications, unreadCount, loading, error, refresh, markRead } = useVendorNotifications();

  const all = useMemo(() => (limit ? notifications.slice(0, limit) : notifications), [notifications, limit]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(ROWS_PER_PAGE_OPTIONS[0]);
  // Stay on a page that exists when the list gets shorter (e.g. after a refresh)
  const lastPage = Math.max(0, Math.ceil(all.length / rowsPerPage) - 1);
  useEffect(() => {
    if (page > lastPage) setPage(lastPage);
  }, [page, lastPage]);

  const shown = useMemo(
    () => (paginate ? all.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : all),
    [all, paginate, page, rowsPerPage]
  );

  const groups = useMemo(() => {
    const order = ["Today", "Yesterday", "Earlier"];
    const map = new Map<string, VendorNotification[]>();
    shown.forEach((n) => {
      const key = getDayGroup(n.createdAt);
      if (!map.has(key)) map.set(key, []);
      map.get(key)!.push(n);
    });
    return order.filter((key) => map.has(key)).map((key) => ({ key, items: map.get(key)! }));
  }, [shown]);

  // Open the notification: go to its order (read ones too) and mark it read
  const handleOpen = async (item: VendorNotification) => {
    const path = getNotificationPath(item);
    if (path) navigate(path);
    if (!item.isRead) {
      const ok = await markRead(item.id);
      if (!ok) showMessage("Couldn't mark the notification as read. Please try again.", "error");
    }
  };

  return (
    <Paper elevation={0} sx={{ px: 2.5, pt: 2.5, pb: 3, mt: `${marginTop}px`, borderRadius: "8px" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
        <Typography component="h2" sx={{ fontWeight: 700, color: COLORS.dark, fontSize: "1.1rem" }}>
          {title}{" "}
          <Box component="span" sx={{ color: COLORS.muted, fontWeight: 500, fontSize: "0.9rem" }}>
            {all.length}
            {unreadCount ? ` · ${unreadCount} unread` : ""}
          </Box>
        </Typography>
        {viewAllPath && (
          <IconButton
            aria-label="View all notifications"
            onClick={() => navigate(viewAllPath)}
            sx={{ border: `1px solid ${COLORS.primary}`, color: COLORS.primary, width: 32, height: 32 }}
          >
            <ArrowOutwardIcon fontSize="small" />
          </IconButton>
        )}
      </Box>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress size={28} sx={{ color: COLORS.primary }} />
        </Box>
      ) : error ? (
        <Box sx={{ textAlign: "center", py: 6 }}>
          <Typography sx={{ color: "#D32F2F" }}>Failed to load notifications.</Typography>
          <ButtonBase onClick={() => refresh(true)} sx={{ mt: 1, color: COLORS.primary, fontWeight: 600, px: 1, borderRadius: 1 }}>
            Try again
          </ButtonBase>
        </Box>
      ) : all.length === 0 ? (
        <Box sx={{ textAlign: "center", py: 6 }}>
          <Typography sx={{ color: COLORS.dark, fontWeight: 600 }}>No notifications yet</Typography>
          <Typography sx={{ color: COLORS.muted, fontSize: "0.875rem", mt: 0.5 }}>
            New order updates will appear here.
          </Typography>
        </Box>
      ) : (
        groups.map((group) => (
          <Box key={group.key} sx={{ mt: 2.5 }}>
            <Typography component="h3" sx={{ color: COLORS.muted, fontSize: "0.8rem", fontWeight: 600, mb: 1 }}>
              {group.key}
            </Typography>
            {group.items.map((item, index) => (
              <React.Fragment key={item.id || index}>
                <ButtonBase
                  onClick={() => handleOpen(item)}
                  disabled={item.isRead && !getNotificationPath(item)}
                  aria-label={`${item.isRead ? "" : "Unread: "}${item.title}${item.body ? `. ${item.body}` : ""}`}
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1.5,
                    p: 1.5,
                    borderRadius: "12px",
                    textAlign: "left",
                    bgcolor: item.isRead ? "transparent" : COLORS.unreadBg,
                    "&.Mui-disabled": { cursor: "default" },
                    "&:hover": { bgcolor: item.isRead ? "transparent" : "#E7F6F2" },
                    "&.Mui-focusVisible": { outline: `2px solid ${COLORS.primary}` },
                  }}
                >
                  <Box
                    sx={{
                      width: 32,
                      height: 32,
                      flexShrink: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "8px",
                      border: `1px solid ${item.isRead ? COLORS.border : COLORS.primary}`,
                    }}
                  >
                    <WSIcons.BsBox2Fill style={{ color: item.isRead ? COLORS.border : COLORS.primary, fontSize: 16 }} />
                  </Box>
                  <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                    <Typography sx={{ color: COLORS.dark, fontSize: "0.9rem", fontWeight: item.isRead ? 400 : 600 }}>
                      {item.title}
                    </Typography>
                    {item.body && (
                      <Typography sx={{ color: item.isRead ? COLORS.muted : COLORS.dark, fontSize: "0.85rem", mt: 0.25, wordBreak: "break-word" }}>
                        {item.body}
                      </Typography>
                    )}
                    <Typography sx={{ color: COLORS.muted, fontSize: "0.75rem", mt: 0.5 }}>{formatTime(item.createdAt)}</Typography>
                  </Box>
                  {!item.isRead && (
                    <Box sx={{ width: 8, height: 8, mt: 0.75, borderRadius: "50%", bgcolor: COLORS.primary, flexShrink: 0 }} />
                  )}
                </ButtonBase>
                {index < group.items.length - 1 && <Divider sx={{ borderColor: "#F0F0F0" }} />}
              </React.Fragment>
            ))}
          </Box>
        ))
      )}

      {paginate && !loading && !error && all.length > ROWS_PER_PAGE_OPTIONS[0] && (
        <TablePagination
          component="div"
          count={all.length}
          page={Math.min(page, lastPage)}
          onPageChange={(_, next) => {
            setPage(next);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
          labelRowsPerPage="Per page:"
          sx={{ mt: 2, borderTop: "1px solid #F0F0F0" }}
        />
      )}
    </Paper>
  );
};

export default LabRecentNotification;
